import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";
import { CommonRequest } from "@/types/http";

async function create(data: any): Promise<CommonRequest<any>> {
  const response = await http
    .postData("/asesmen-awal-ranap-anak", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function update(id: number, data: any): Promise<CommonRequest<any>> {
  const response = await http
    .putData(`/asesmen-awal-ranap-anak/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function getByRegister(
  register_id: string | number
): Promise<CommonRequest<any>> {
  const response = await http
    .getData(`/register/${register_id}/asesmen-awal-ranap-anak`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function find(id: number): Promise<CommonRequest<any>> {
  const response = await http
    .getData(`/asesmen-awal-ranap-anak/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function destroy(id: number): Promise<CommonRequest<undefined>> {
  const response = await http
    .deleteData(`/asesmen-awal-ranap-anak/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function verifyDpjp(
  id: number,
  data: any
): Promise<CommonRequest<any>> {
  const response = await http
    .postData(`/asesmen-awal-ranap-anak/${id}/verify-dpjp`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function verifyPpja(
  id: number,
  data: any
): Promise<CommonRequest<any>> {
  const response = await http
    .postData(`/asesmen-awal-ranap-anak/${id}/verify-ppja`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

function printPdf(id: number) {
  window.open(
    `${http.getAPI()}/asesmen-awal-ranap-anak/${id}/pdf`,
    "_blank"
  );
}

async function masters(): Promise<CommonRequest<any>> {
  const response = await http
    .getData("/asesmen-awal-ranap-anak-masters")
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

/**
 * Live preview Z-score WHO + ambang RR pneumonia WHO tanpa menyimpan.
 * Berguna untuk reactive UI antropometri & klasifikasi pneumonia.
 */
async function previewCompute(data: any): Promise<CommonRequest<any>> {
  const response = await http
    .postData("/asesmen-awal-ranap-anak-preview", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

export default {
  create,
  update,
  getByRegister,
  find,
  destroy,
  verifyDpjp,
  verifyPpja,
  printPdf,
  masters,
  previewCompute
};
